import CreateChallengeLiveModalComponent from "./CreateChallengeLiveModalComponent";

export default CreateChallengeLiveModalComponent;